import { useState } from 'react'
import useBoonPrice from 'web/hooks/useBoonPrice'
import useBoundCult from 'web/hooks/useBoundCult'
import useEnvironment from 'web/hooks/useEnvironment'
import usePolygonBlockNumber from 'web/hooks/usePolygonBlockNumber'
import usePolygonBlockTime from 'web/hooks/usePolygonBlockTime'
import { Boon } from 'web/lib/boon'
import { BoonGalleryContext } from './GalleryBoonItems'

export type BoonItemProps = {
  boon: Boon
  context: BoonGalleryContext
  onClick?: Function
}

export default function GalleryBoonItem({ boon, context, onClick }: BoonItemProps) {
  const { isBeta } = useEnvironment()

  const currentCult = useBoundCult()
  const boonPrice = useBoonPrice(boon)

  const polygonBlock = usePolygonBlockNumber(true)
  const secondsPerBlock = usePolygonBlockTime()

  return (
    <li className="relative" key={boon.uid}>
      <a
        className="block bg-gray-800 space-y-4 m-1 p-5 lg:p-8 rounded-lg no-underline text-white hover:text-white hover:no-underline hover:text-gray-500 hover:bg-gray-900 focus:ring-2 focus:ring-red-500 cursor-pointer transition-all"
        onClick={(e) => {
          e.stopPropagation()
          onClick(boon)
        }}
      >
        <div className="flex justify-center rounded-lg md:px-8 md:py-2">
          <img className="w-full" src={boon.imageUrl} alt="" />
          <span className="sr-only">View details for {boon.name}</span>
        </div>
        <div className="flex flex-col items-center space-y-2">
          <h6 className="block text-center truncate">{boon.name}</h6>

          {context == BoonGalleryContext.Wallet && boon.isActivated && !boon.isExpired && currentCult && boon.activatable &&
            <p>
              <span className="bg-red-500 text-white px-2 py-1 text-sm rounded-xl">
                Activated
              </span>
            </p>}

          {context == BoonGalleryContext.Wallet && !boon.isActivated && !boon.isExpired && currentCult && boon.activatable &&
            <p>
              <span className="bg-gray-900 text-gray-500 px-2 py-1 text-sm rounded-xl">
                Inactive
              </span>
            </p>}

          <p className="text-sm text-gray-400 hidden md:block whitespace-nowrap">
            {boon.isActivated ?
              <>{boon.getTimeRemaining(polygonBlock, secondsPerBlock).timeForHumans()} remaining</>
              :
              boon.shortDescription}
          </p>

          {context == BoonGalleryContext.Exchange &&
            <div className="pt-2">
              {/* STUPID ANNOYING DIV WRAPPER EXISTS BECAUSE space-y-2 IS METRICALLY SPACED NOT OPTICALLY SPACED */}
              <p className="text-sm text-red-500 bg-red-300 rounded-full px-4 py-1">
                <span className="text-white font-bold">{(isBeta && boonPrice.toLocaleString()) || '???'}</span>&nbsp;$BLOOD
              </p>
            </div>}
        </div>
      </a>
    </li>
  )
}
